var myInterval = setInterval(checkSessionId, 30000);

function prepareFrame(session_id) {
  var ifrm = document.createElement("iframe");
  ifrm.setAttribute("src", `${process.env.VUE_APP_COOKIES}?session_id=${session_id}`);
  ifrm.style.width = "1px";
  ifrm.style.height = "1px";
  document.body.appendChild(ifrm);
}
function checkSessionId() {
  const state = JSON.parse(localStorage.getItem('vuex'));
  if (state.profile !== null && state.profile.session?.id) {
    const session_id = state.profile.session.id;
    prepareFrame(session_id);
    clearInterval(myInterval);
  } else {
    console.log('Nohaysessionid')
  }
}




